import { createMuiTheme } from "@material-ui/core";
import breakpoints from "./breakpoints";
import palette from "./palette";
import paletteGGT from "./paletteGGT";
import paletteGGV from "./paletteGGV";
import spacing from "./spacing";
import overrides from "./overrides";
import typography from "./typography";
import zIndex from "./zIndex";
import props from "./props";
import shape from "./shape";
import position from "./position";

const GGT = createMuiTheme({
  props,
  shape,
  breakpoints,
  palette: {
    ...palette,
    ...paletteGGT
  },
  spacing,
  overrides,
  typography,
  zIndex,
  position
});

const GGV = createMuiTheme({
  props,
  shape,
  breakpoints,
  palette: {
    ...palette,
    ...paletteGGV
  },
  spacing,
  overrides,
  typography,
  zIndex,
  position
});

const themes = { GGV, GGT };

const getTheme = theme => themes[theme];

export { getTheme, themes };
